import { ReactNode } from 'react';

import { Subscriptions } from './components/subscriptions';

export type WebhooksProps = {
  section?: ReactNode;
};

export function Webhooks({ section }: WebhooksProps): JSX.Element {
  return <>{section || <Subscriptions />}</>;
}
